// Error class abstraction that enables framework agnostic error handling
export class WebApiRequestCancellationError extends Error {
    constructor() {
        super(...arguments);
        this.name = "WebApiRequestCancellationError";
    }
}
